module.exports = __webpack_public_path__ + "media/images/prev-arrow-53383c70d9b5957c09c0682d2b2af052.png";